import styles from './RefineChecklist.less';

import React from 'react';
import classnames from 'classnames';

import QualifiedLink from 'QualifiedLink/QualifiedLink';

const renderChecklist = function(props, options, handleSelection, depth) {
  const { path, childrenKey, filter } = props;

  const filteredOptions = options.filter(filter);

  return filteredOptions.length > 0 && (
    <ul className={`${styles.root} ${depth ? styles[`root_isDepthOf${depth}`] : ''}`}>
      {
        filteredOptions.map(option => (
          <li
            onClick={handleSelection}
            key={option.value}
            className={classnames({
              [styles.item]: true,
              [styles.item_isAll]: option.type === 'all'
            })}
            data-automation={`item-depth-${depth}`}>
            <div data-automation="item-text">
              <QualifiedLink
                data-automation={`${option.type === 'all' ? 'all-' : '' }${option.value}`}
                path={path}
                params={option.refineParams}
                role="checkbox"
                aria-checked={option.isActive}
                aria-label={ `${option.label} ${option.displayCount ? `${option.displayCount} jobs` : ''}` }
                className={`${styles.link} ${(option.isActive ? styles.link_isActive : '')}`}>
                { option.label }
              </QualifiedLink>
              {
                !option.displayCount ? null : (
                  <span className={styles.count}>
                    { ` ${option.displayCount}` }
                  </span>
                )
              }
            </div>
            {
              !option[childrenKey] ? null : (
                renderChecklist(props, option[childrenKey], handleSelection, depth + 1)
              )
            }
          </li>
        ))
      }
    </ul>
  );
};

export default class RefineChecklist extends React.Component {

  static propTypes = {
    options: React.PropTypes.arrayOf(
        React.PropTypes.shape({
          value: React.PropTypes.string.isRequired,
          label: React.PropTypes.string.isRequired,
          displayCount: React.PropTypes.string,
          isActive: React.PropTypes.bool.isRequired,
          refineParams: React.PropTypes.object.isRequired
        })
      ).isRequired,
    path: React.PropTypes.string.isRequired,
    childrenKey: React.PropTypes.string,
    filter: React.PropTypes.func,
    handleSelection: React.PropTypes.func.isRequired
  };

  static defaultProps = {
    filter: () => true
  };

  constructor(props) {
    super(props);

    this.handleSelection = this.handleSelection.bind(this);
  }

  handleSelection(event) {
    event.stopPropagation();
    this.props.handleSelection();
  }

  render() {
    return renderChecklist(this.props, this.props.options, this.handleSelection, 0);
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/SearchBar/components/ClassificationList/components/RefineChecklist/RefineChecklist.js
 **/